import type React from 'react'
import './index.less'

export interface LabelTextProps {
  text?: string | React.ReactNode
  inputLabel?: boolean
}
const LabelText = ({text, inputLabel}: LabelTextProps) => {
  return <span className={inputLabel ? `astro-ui-label-text input-prefix` : 'astro-ui-label-text'}>{text}</span>
}

export default LabelText
